{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Templates",
    "DESCRIPTION": "Veja os templates de mensagens sincronizados a partir das suas caixas de entrada do WhatsApp. Para criar ou editar um template, faça-o através do seu fornecedor.",
    "COUNT": "{n} template | {n} templates",
    "LEARN_MORE": "Saber mais sobre os templates do WhatsApp",
    "SYNC_TEMPLATES": "Sincronizar templates",
    "SYNC_SUCCESS": "A sincronização de templates foi iniciada para todas as caixas de entrada do WhatsApp. As atualizações podem demorar alguns minutos.",
    "PARTIAL_SYNC_ERROR": "A sincronização de templates foi iniciada para algumas caixas de entrada do WhatsApp, mas não foi possível sincronizar as restantes.",
    "SYNC_ERROR": "Não foi possível iniciar a sincronização de templates. Por favor, tente novamente.",
    "SEARCH_PLACEHOLDER": "Procurar por conteúdo ou nome...",
    "MANAGE_IN_META": "Gerir na Meta",
    "LOADING": "A carregar templates do WhatsApp...",
    "EMPTY": "Nenhum template do WhatsApp encontrado.",
    "NO_RESULTS": "Nenhum template corresponde aos seus filtros.",
    "FETCH_ERROR": "Não foi possível carregar os templates do WhatsApp. Por favor, tente novamente.",
    "PARTIAL_FETCH_ERROR": "Não foi possível carregar alguns templates do WhatsApp. Por favor, tente novamente.",
    "LAST_SYNC_ATTEMPT": "Última tentativa de sincronização em {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Não submetido para aprovação do WhatsApp"
    },
    "FILTERS": {
      "ALL_INBOXES": "Todas as caixas de entrada",
      "ALL_LANGUAGES": "Todos os idiomas",
      "ALL_TYPES": "Todos os tipos"
    },
    "TYPES": {
      "TEXT": "Texto",
      "IMAGE": "Imagem",
      "VIDEO": "Vídeo",
      "DOCUMENT": "Documento",
      "CALL_TO_ACTION": "Apelo à ação",
      "COPY_CODE": "Copiar código"
    },
    "PREVIEW": {
      "TITLE": "Pré-visualização do template",
      "DESCRIPTION": "Pré-visualize o aspeto deste template no WhatsApp.",
      "OPEN": "Pré-visualizar {name}",
      "CLOSE": "Fechar pré-visualização",
      "DETAILS": "Detalhes do template",
      "STATUS": "Situação",
      "TYPE": "Tipo de conteúdo",
      "CATEGORY": "Categoria",
      "LANGUAGE": "Idioma",
      "INBOXES": "Caixas de entrada"
    }
  }
}
